export default __webpack_public_path__ + "static/media/chart-loader.b9c5c953.svg";